import { Divider, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import CreateProductForm from "./CreateProducts";
import ConfigureNewProduct from "./ConfigureNewProduct";
import ProductMetadata from "./ProductMetadata";
import CreateTeamProductForm from "./Team Products/CreateTeamProducts";

const Products = () => {
  const [activeTab, setActiveTab] = useState(0);

  const activeComponents = [
    <CreateProductForm />,
    <CreateTeamProductForm />,
    <ConfigureNewProduct />,
    <ProductMetadata />,
  ]

  return (
    <div
      style={{
        width: "80%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "column",
      }}
    >
      <Tabs value={activeTab} onChange={(e, n) => setActiveTab(n)}>
        <Tab label="Create Products" />
        <Tab label="Create Team Products" />
        <Tab label="Product Configuration" />
        <Tab label="Product Metadata" />
      </Tabs>

      <Divider />

      {activeComponents[activeTab]}
    </div>
  );
};

export default Products;
